import React, { useEffect } from "react";
import FileUploadSingle from "../../../components/form/FileUploadSingle";
import useForm from "../../../hooks/useForm";
import useMutation from "../../../hooks/useMutation";
import Button from "../../../components/form/Button";

import { toast } from "react-toastify";
import { mediaAddEdit } from "../../../services/mediaService";

const validation = {
  file: { required: true, message: "Media file is required" },
};

const ManageMedia = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        file: data?.file?.url || "",
      });
    }
  }, [data]);

  const { mutate, isPending } = useMutation({
    mutationFn: async (val) => {
      return await mediaAddEdit({
        ...(data?._id && { id: data._id }),
        file: val.file,
      });
    },
    onSuccess: (res) => {
      toast.success(
        data?._id ? "Media updated successfully!" : "Media added successfully!"
      );
      getResponse(res);
    },
    onError: (err) => {
      toast.error(err?.error || "Something went wrong");
    },
  });

  return (
    <form onSubmit={(e) => handleSubmit(e, mutate)}>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <FileUploadSingle
            size="small"
            label="Upload Image"
            value={values?.file}
            onChange={(file) =>
              handleChange({ target: { name: "file", value: file } })
            }
            accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.tiff,.svg,image/*"
            {...formValidate(errors, "file")}
          />
        </div>

        <div className="col-span-12 flex justify-center gap-4 mt-4">
          <Button
            buttonType="submit"
            buttonLabel="Save"
            buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            {...(isPending && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel="Cancel"
            buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageMedia;
